module.exports = __webpack_public_path__ + "static/img/thumb_23.07a609e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_23.png
// module id = thcd
// module chunks = 0